<template>
  <footer style="background-color: rgb(10, 36, 99);">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8 mb-8">
        <!-- Company Info -->
        <div>
          <div class="flex items-center gap-3 mb-4">
            <img :src="assets('images/logo_white.png')" alt="LEVIY Logo" class="w-10 h-10 rounded-lg" />
            <div>
              <div class="text-xl tracking-wider" style="color: rgb(255, 255, 240);">LEVIY {{ $t('navBar.brandName') }}</div>
              <div class="text-xs tracking-wide opacity-70" style="color: rgb(255, 255, 240);">{{ $t('navBar.brandSubtitle') }}</div>
            </div>
          </div>
          <div class="space-y-3" style="color: rgb(255, 255, 240); opacity: 0.8;">
            <a href="tel:400-852-6298" class="flex items-center text-sm hover:opacity-100 transition-opacity">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2">
                <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path>
              </svg>
              <span>400-852-6298</span>
            </a>
            <a href="mailto:Leviygo@leviyglobal.com" class="flex items-center text-sm hover:opacity-100 transition-opacity">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2">
                <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                <rect x="2" y="4" width="20" height="16" rx="2"></rect>
              </svg>
              <span>Leviygo@leviyglobal.com</span>
            </a>
            <div class="flex items-start text-sm">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2 mt-1 flex-shrink-0">
                <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
              <span>{{ $t('footer.address') }}</span>
            </div>
          </div>
        </div>

        <!-- Core Services -->
        <div>
          <h4 class="mb-4" style="color: rgb(212, 175, 55); font-size: 1.125rem;">{{ $t('footer.coreServices') }}</h4>
          <ul class="space-y-3" style="color: rgb(255, 255, 240); opacity: 0.8;">
            <li v-for="(item, index) in coreServices" :key="index">
              <router-link class="transition-colors duration-200 text-sm hover:opacity-100" :to="item.href" style="color: rgb(255, 255, 240); opacity: 0.8;">
                {{ $t(item.label) }}
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Business Services -->
        <div>
          <h4 class="mb-4" style="color: rgb(212, 175, 55); font-size: 1.125rem;">{{ $t('navBar.businessServices') }}</h4>
          <ul class="space-y-3" style="color: rgb(255, 255, 240); opacity: 0.8;">
            <li v-for="(item, index) in businessServices" :key="index">
              <router-link class="transition-colors duration-200 text-sm hover:opacity-100" :to="item.href" style="color: rgb(255, 255, 240); opacity: 0.8;">
                {{ $t(item.label) }}
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Legal Services -->
        <div>
          <h4 class="mb-4" style="color: rgb(212, 175, 55); font-size: 1.125rem;">{{ $t('navBar.legalServices') }}</h4>
          <ul class="space-y-3" style="color: rgb(255, 255, 240); opacity: 0.8;">
            <li v-for="(item, index) in legalServices" :key="index">
              <router-link class="transition-colors duration-200 text-sm hover:opacity-100" :to="item.href" style="color: rgb(255, 255, 240); opacity: 0.8;">
                {{ $t(item.label) }}
              </router-link>
            </li>
          </ul>
        </div>

        <!-- About Us -->
        <div>
          <h4 class="mb-4" style="color: rgb(212, 175, 55); font-size: 1.125rem;">{{ $t('navBar.about') }}</h4>
          <ul class="space-y-3" style="color: rgb(255, 255, 240); opacity: 0.8;">
            <li><router-link class="transition-colors duration-200 text-sm hover:opacity-100" :to="'/knowledge'" style="color: rgb(255, 255, 240); opacity: 0.8;">{{ $t('navBar.knowledge') }}</router-link></li>
            <li><router-link class="transition-colors duration-200 text-sm hover:opacity-100" :to="'/about'" style="color: rgb(255, 255, 240); opacity: 0.8;">{{ $t('navBar.about') }}</router-link></li>
            <li><router-link class="transition-colors duration-200 text-sm hover:opacity-100" :to="'/contact'" style="color: rgb(255, 255, 240); opacity: 0.8;">{{ $t('navBar.contact') }}</router-link></li>
          </ul>
        </div>

        <!-- Friendly Links -->
        <div>
          <h4 class="mb-4" style="color: rgb(212, 175, 55); font-size: 1.125rem;">{{ $t('footer.friendlyLinks') }}</h4>
          <ul class="space-y-3" style="color: rgb(255, 255, 240); opacity: 0.8;">
            <li v-for="(link, index) in friendlyLinks" :key="index">
              <a :href="link.href" target="_blank" rel="noopener noreferrer" class="transition-colors duration-200 text-sm hover:opacity-100" style="color: rgb(255, 255, 240); opacity: 0.8;">
                {{ $t(link.label) }}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Copyright -->
      <div class="py-8 border-t" style="border-color: rgba(212, 175, 55, 0.2);">
        <div class="flex flex-col justify-center items-center gap-4">
          <p class="text-sm" style="color: rgb(255, 255, 240); opacity: 0.6;">{{ $t('footer.copyright') }}</p>

          <!-- 备案信息 -->
          <div class="flex flex-wrap justify-center items-center gap-4">
            <!-- 公安备案 -->
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo" rel="noreferrer" target="_blank" class="flex items-center gap-1 text-xs transition-opacity hover:opacity-80" style="color: rgb(255, 255, 240); opacity: 0.6;">
              <img :src="assets('images/guohui.png')" alt="公安备案" class="w-4 h-4">
              <span>浙公网安备33010502012693号</span>
            </a>

            <!-- ICP备案 -->
            <a href="https://beian.miit.gov.cn/" rel="noreferrer" target="_blank" class="text-xs transition-opacity hover:opacity-80" style="color: rgb(255, 255, 240); opacity: 0.6;">
              浙ICP备2026005201号
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { assets } from '../utils/util'

const coreServices = [
  { href: '/hk-registration', label: 'footer.hkRegistration' },
  { href: '/offshore-registration', label: 'footer.offshoreRegistration' },
  { href: '/odi-investment', label: 'footer.odiInvestment' },
  { href: '/vie-structure', label: 'footer.vieStructure' },
]

const businessServices = [
  { href: '/business-services#company-registration', label: 'footer.companyRegistration' },
  { href: '/business-services#banking', label: 'footer.banking' },
  { href: '/business-services#accounting', label: 'footer.accounting' },
  { href: '/business-services#company-search', label: 'footer.companySearch' },
  { href: '/business-services#cross-border-investment', label: 'footer.crossBorderInvestment' },
  { href: '/business-services#tax-planning', label: 'footer.taxPlanning' },
  { href: '/business-services#international-solutions', label: 'footer.internationalSolutions' },
]

const legalServices = [
  { href: '/legal-services#legal-opinion', label: 'footer.legalOpinion' },
  { href: '/legal-services#notarization', label: 'footer.notarization' },
  { href: '/legal-services#due-diligence', label: 'footer.dueDiligence' },
  { href: '/legal-services#contract-drafting', label: 'footer.contractDrafting' },
  { href: '/legal-services#property-investigation', label: 'footer.propertyInvestigation' },
  { href: '/legal-services#arbitration-enforcement', label: 'footer.arbitrationEnforcement' },
  { href: '/legal-services#general-legal', label: 'footer.generalLegal' },
]

const friendlyLinks = [
  { href: 'https://fdi.mofcom.gov.cn', label: 'footer.friendlyLink1' },
  { href: 'https://www.eccpit.com', label: 'footer.friendlyLink2' },
  { href: 'https://www.safe.gov.cn', label: 'footer.friendlyLink3' },
  { href: 'https://business.linkedin.com', label: 'footer.friendlyLink4' },
  { href: 'https://www.wipo.int', label: 'footer.friendlyLink5' },
  { href: 'https://www.uspto.gov', label: 'footer.friendlyLink6' },
]
</script>
